import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import React from 'react'
import {notEmpty} from 'views/Shared'
import {courseClassSchema} from "../../../../apis";

const CourseClassEntity = ({item, children, defaultItem}) => (
  <SelectEntityItem
    item={item}
    defaultItem={defaultItem}
    schema={courseClassSchema}>
    {(data) => children(data)}
  </SelectEntityItem>
)

export const CourseClassEntities = ({items, children, defaultItem}) => (
  <SelectEntityItem
    item={items}
    defaultItem={defaultItem}
    schema={[courseClassSchema]}>
    {(data = []) => children(_.filter(data, notEmpty))}
  </SelectEntityItem>
)

export default CourseClassEntity
